import React, { useReducer } from 'react';
import DialogBaseContext from './dialogBaseContext';
import DialogBaseReducer from './dialogBaseReducer';


const DialogBaseProvider = (props)=>{
    const initialState= {
        contador:1,
        isOpen:false
    }

    const [ state, dispatch ] = useReducer(DialogBaseReducer, initialState);


    const refresh = ()=>{
        dispatch({
            type: 'REFRESH',
            payload: 1
        });
    }

    const toggle =(active)=>{
        dispatch({ // Swithc isOpen
            type: 'TOGGLE',
            payload: active
        });
    }

    return (
        <DialogBaseContext.Provider 
        value={{
            contador:1,
            isOpen: state.isOpen,
            refresh,
            toggle,
        }}
        >
            {props.children}
        </DialogBaseContext.Provider>
    )


}


export default DialogBaseProvider;




